import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useAdmitUserMutation } from "@/graphql/generated";
import { toaster } from "@/utils/toaster";
import { Plus } from "lucide-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function AdmitPatient({ hash }: { hash: string }) {
  const { t } = useTranslation();
  const [admitUser, { loading, error }] = useAdmitUserMutation({
    refetchQueries: ["GetWaitingUsers", "GetUpcomingUsers"],
    awaitRefetchQueries: true,
  });
  useEffect(() => {
    if (error) toaster("error", t("error"));
  }, [error, t]);

  const handleClick = async () => {
    await admitUser({ variables: { target: hash } });
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant={"outline"}
          className="w-8 h-8 p-1"
          disabled={loading}
          onClick={handleClick}
          onPointerDown={(e) => e.stopPropagation()}
        >
          {loading ? <Spinner /> : <Plus size={20} strokeWidth={1.5} />}
        </Button>
      </TooltipTrigger>
      <TooltipContent side="top">{t("admit")}</TooltipContent>
    </Tooltip>
  );
}
